module.exports = __webpack_public_path__ + "static/media/miraculum_1924.a6e6122a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/miraculum_1924.webp
// module id = 641
// module chunks = 0